import api from '@/api';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { resetRouter } from '@/router';

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: ''
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  }
};

const actions = {
  // user login
  async login({ commit }, userInfo) {
    const { username, password } = userInfo;
    const response = await api.user.login({
      username: username.trim(),
      password: password
    });
    const { data } = response;
    commit('SET_TOKEN', data.token);
    commit('SET_NAME', '管理员');
    setToken(data.token);
  },

  // user logout
  async logout({ commit }) {
    await api.user.logout();
    removeToken();
    resetRouter();
    commit('RESET_STATE');
  },

  // remove token
  resetToken({ commit }) {
    removeToken();
    commit('RESET_STATE');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
